


















import { Component, Prop, Vue } from 'vue-property-decorator';
import UserIcon from '@/components/global/UserIcon.vue';

@Component({
  components: {
    UserIcon,
  },
})
export default class AvatarIcon extends Vue {
  @Prop({ required: true }) userId!: string;
  @Prop({ required: true }) tablePosition!: number;
  @Prop({ required: true }) breaking!: boolean;

  showProfile() {
    this.$router.push({ name: 'User', params: { userId: this.userId } });
  }
}
